import React, {useEffect, useState} from "react"
import {Link} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api";
import FAQItem from "../Components/FAQItem";

function Help() {

    const [FAQData, setFAQData] = useState()

    const getFAQ = () => {
        api.get(`/api/faq`).then((response) => {
            setFAQData(response.data)
        }).catch(requestFailed)
    }

    useEffect(() => {
        getFAQ()
    }, [])

    return (
        <div id="help">
            <h2>Pages</h2>
            <h3><Link to="/home">/home</Link></h3>
            <p>The home page allows you to generate guides to help you level up. First, enter a general skill you
                would like to work on and improve (examples: coding, dancing). You will be prompted with three
                subcategories that narrow down your goal. Selecting one of these will generate detailed step-by-step
                instructions on how to work towards achieving your goal, with relevant resources included if available.</p>
            <h3><Link to="/explore">/explore</Link></h3>
            <p>The explore page features community-made posts and allows you to create guides for others or discover
                guides made by others. Navigate the explore page using trending tags, or use the search bar. The search
                bar can be used to search for tags as well as users; click on the search symbol or press 'ctrl' to switch
                between tag search and user search.</p>
            <h3><Link to="/challenge">/challenge</Link></h3>
            <p>The challenge page features a new challenge every week that is universal to all users. A countdown indicates
                the time remaining until the challenge expires and a new one is created. Those who have no specific goal in
                mind can challenge themselves to level up something new every week.</p>
            <h3><Link to="/legal">/legal</Link></h3>
            <p>Boring (Terms of Service & Privacy Policy).</p>
            <h2>FAQ</h2>
            {FAQData && FAQData.map((item, index) => (
                <FAQItem key={index} question={item.question} answer={item.answer}/>
            ))}
        </div>
    )
}

export default Help;